import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=ab6bcfbc&"
import script from "./validation.vue?vue&type=script&lang=js&"
export * from "./validation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab6bcfbc')) {
      api.createRecord('ab6bcfbc', component.options)
    } else {
      api.reload('ab6bcfbc', component.options)
    }
    module.hot.accept("./validation.vue?vue&type=template&id=ab6bcfbc&", function () {
      api.rerender('ab6bcfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/validation.vue"
export default component.exports